import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import reportsGridSectionReport from './reportsGridSectionReport.js';
import arrayEntry from '../fragments/arrayEntry.js';
var schema = defineObject('reportsGridSection', {
    reports: {
        type: 'array',
        title: 'Reports',
        of: [
            {
                type: 'reportsGridSectionReport'
            }
        ]
    }
}, [
    reportsGridSectionReport.schema.reportsGridSectionReport
]);
var validator = z.object({
    reports: z.array(reportsGridSectionReport.validator.merge(arrayEntry.validator))
}).partial();
schema.reportsGridSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=reportsGridSection.js.map